import jsBridge from '@hb/hb-jsbridge';
// app中link跳转
const clickLinkInApp = async function (enableJsbridge, playUrl, thumbnailUrl) {
  // 跳转路由
  const patientRoute = `hdf://knowledge/haodfWebVideoPlay?videoURL=${encodeURIComponent(playUrl)}&coverURL=${encodeURIComponent(thumbnailUrl)}`;
  if (!enableJsbridge) {
    window.location.href = patientRoute;
  } else {
    const data = {
      videoUrl: playUrl,
      coverUrl: thumbnailUrl
    };
    jsBridge.callCHandler({
      nativeMethod: 'onVideoPreview',
      data
    });
  }
};
// 获取属性
const getAttribute = (dom) => {
  const href = dom.getAttribute('href') || '';
  const hdfLinkType = dom.getAttribute('data-hdflinktype') || '';
  const playUrl = dom.getAttribute('data-playurl') || '';
  const thumbnailUrl = dom.getAttribute('data-thumbnailurl') || '';
  return {
    linkHref: href,
    hdfLinkType,
    playUrl,
    thumbnailUrl
  };
};
// 点击超链的回调
const clickLinkHandler = function (options, { linkHref, playUrl, thumbnailUrl }) {
  const { env = 'web', enableJsbridge = true } = options;
  if (env === 'web') {
    window.open(linkHref);
  } else {
    clickLinkInApp(enableJsbridge, playUrl, thumbnailUrl);
  }
};
// 对超链接的点击事件增加劫持
export const proxyLinkClick = function (options) {
  const linkList = document.querySelectorAll('.hdf-link');
  const linkListLen = linkList && linkList.length;
  if (linkListLen) {
    Array.from(linkList).forEach((linkDom) => {
      linkDom.addEventListener('click', function (event) {
        const { linkHref, hdfLinkType, playUrl, thumbnailUrl } = getAttribute(this);
        // 如果是小视频类型就禁止默认事件
        if (hdfLinkType === 'video') {
          event.preventDefault && event.preventDefault();
          event.stopPropagation && event.stopPropagation();
          clickLinkHandler(options, { linkHref, playUrl, thumbnailUrl });
        }
      });
    });
  }
};
